export default function copyReferalLinkToClipboard(referralCode:string){
    navigator.clipboard.writeText(generateReferalLink(referralCode))
  }

function generateReferalLink(referralCode:string){
    return process.env.REACT_APP_CLIENT_URL + '/register?referrerCode=' + referralCode
}
